window.cyber_hub__change_tab = function(tab) {
    if(tab === undefined) return false;

    if(tab === 'social-media') {
        $(".card-body-social-media").each(function() {
            $(this).scroll();
            $(this).animate({ scrollTop: 0}, 100);
            $(this).animate({ scrollTop: 300}, 1000);
        });
    }
}

export default {
    init() {

        var scrolled = false;
        $(window).scroll(function(){
            if(!scrolled) {
                var scrollTop = $(this).scrollTop();
                if(scrollTop > 300) {
                    scrolled = true;
                    setTimeout(function() {
                        window.cyber_hub__change_tab('social-media');
                    }, 1000);
                }
            }
        });

        $("#hub-tab-1").click(function() {
            setTimeout(function() {
                window.cyber_hub__change_tab('social-media');
            }, 1000);
        });
      
        var date_filters    = $(".hub-date-filter");
        var date_filter_all = $(".hub-date-filter-all");
        var date_content    = $(".hub-date-filter-content");

        date_filters.click(function(event) {
            event.preventDefault();

            var start = $(this).attr("data-start");
            var end   = $(this).attr("data-end");
            var str   = $(this).text();

            $("#filterByDateDropdown").text(str);
            $("#filterByTopicDropdown").text("Filter by Topic");

            if(start !== undefined) start = parseInt(start);
            if(end   !== undefined) end   = parseInt(end);

            date_content.hide();

            date_content.each(function() {
                var content_date = $(this).attr("data-timestamp");
                if(content_date >= start && content_date <= end) $(this).show();
            });
        });

        date_filter_all.click(function(event) {
            event.preventDefault();
            $("#filterByDateDropdown").text("All");
            $("#filterByTopicDropdown").text("Filter by Topic");
            date_content.show();
        });

        // Date Range
        window.hub_date_range_filter = function() {
            try {
                var date_content = $(".hub-date-filter-content");

                var start = $(".hub-date-filter-range [name='start']").val();
                var end   = $(".hub-date-filter-range [name='end']").val();

                var startDate = new Date(start);
                var endDate   = new Date(end);

                var startTime = startDate.getTime();
                var endTime   = endDate.getTime();

                // Start
                if( ! isNaN( startTime ) && isNaN( endTime ) ) {
                    date_content.hide();

                    date_content.each(function() {
                        var content_date = $(this).attr("data-timestamp");
                        if(content_date >= startTime / 1000) $(this).show();
                    });
                }

                // End
                if( isNaN( startTime ) && ! isNaN( endTime ) ) {
                    date_content.hide();

                    date_content.each(function() {
                        var content_date = $(this).attr("data-timestamp");
                        if(content_date <= endTime / 1000) $(this).show();
                    });
                }

                // Start & End
                if( ! isNaN( startTime ) && ! isNaN( endTime ) ) {
                    date_content.hide();

                    date_content.each(function() {
                        var content_date = $(this).attr("data-timestamp");
                        if(content_date >= startTime / 1000 && content_date <= endTime / 1000) $(this).show();
                    });
                }
            }
            catch(err) {
                console.error(err);
            }
        }

        /**
         * Region
         */

        var region_filters    = $(".hub-region-filter");
        var region_filter_all = $(".hub-region-filter-all");
        var region_content    = $(".hub-region-content");

        region_filters.click(function(event) {
            event.preventDefault();

            var region = $(this).attr("data-region");
            $("#filterByRegionDropdown").text($(this).text());
            region_content.hide();

            region_content.each(function() {
                var content_region = $(this).attr("data-region");
                if(content_region === region) $(this).show();
            });
        });

        region_filter_all.click(function(event) {
            event.preventDefault();
            $("#filterByRegionDropdown").text("All");
            region_content.show();
        });

        /**
         * Topic
         */

        var topic_filters    = $(".hub-topic-filter");
        var topic_filter_all = $(".hub-topic-filter-all");
        var topic_content    = $(".hub-topic-content");

        topic_filters.click(function(event) {
            event.preventDefault();

            var topic = $(this).attr("data-topic");
            $("#filterByTopicDropdown").text($(this).text());
            $("#filterByDateDropdown").text("Filter by Date");
            topic_content.hide();

            topic_content.each(function() {
                var content_topic = $(this).attr("data-topic");
                if(content_topic === topic) $(this).show();
            });
        });

        topic_filter_all.click(function(event) {
            event.preventDefault();
            $("#filterByTopicDropdown").text("All");
            $("#filterByDateDropdown").text("Filter by Date");
            topic_content.show();
        });

        // Read More
        $(document).on("click", ".card-latest-reports .more[data-id]", function(e){
            e.preventDefault();

            var post_id = $(this).attr("data-id");
            if (post_id) {
                $(".card-latest-reports li[data-id='" + post_id + "']").toggleClass("show-all-content");
                
                var curr_text = $(this).text();
                if(curr_text == 'Read More >') $(this).text("Read Less >");
                else $(this).text("Read More >");
            }
        });

        $(document).on("click", ".card-latest-reports .tag", function(){
            var tag = $(this).data('href');

            $('.card-latest-reports .hub-topic-content').each(function(){
                var tags = $(this).attr('data-tags').split(" ");
                
                if (tags.indexOf(tag) !== -1) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            })

            $('.tag-filter').show();
            $('.selected-tag').html('#' + tag + ' <span class="x">x</span>');

            return false;
        });

        $(document).on("click", ".card-latest-reports .selected-tag", function(){
            $('.card-latest-reports .hub-topic-content').show();
            $('.tag-filter').hide();
        });
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/social-hub.js